import api from "@/lib/axios";
import { formatDateTimeWithoutTz } from "@/lib/utils";

export type AnnouncementType = "info" | "feature" | "maintenance" | "warning";

export interface Announcement {
  id: number;
  title: string;
  description: string;
  notification_target: number;
  type: AnnouncementType;
  scheduled_at: string | null;
  expires_at: string | null;
  image_url?: string;
  created_at: string;
  updated_at?: string;
  status?: number;
  is_read?: boolean;
}

export function formatAnnouncementDateTime(
  value: string | null | undefined,
): string {
  if (!value) return "";
  return formatDateTimeWithoutTz(value);
}

export const announcementsApi = {
  async listRecent(): Promise<Announcement[]> {
    const response = await api.get<{ data: Announcement[] }>(
      "/platform_notification/recent",
    );
    return response.data.data ?? [];
  },

  async listUnread(): Promise<Announcement[]> {
    const response = await api.get<{ data: Announcement[] }>(
      "/platform_notification/unread",
    );
    return response.data.data ?? [];
  },

  async markAsRead(id: number): Promise<void> {
    await api.post(`/platform_notification/${id}/mark_as_read`);
  },

  async markAllAsRead(): Promise<void> {
    await api.post("/platform_notification/mark_all_as_read");
  },
};
